<template>
  <div class="bdp-panel">
    <validation-observer ref="refFormObserver">
      <div class="bdp-header">
        <div class="bdp-header-icon">
          <i class="fas fa-ban"></i>
        </div>
        <div>
          <div class="bdp-header-title">{{ msg('Block') }}</div>
          <div class="bdp-header-sub">{{ msg('Block calendar dates for a property') }}</div>
        </div>
      </div>

      <b-row class="bdp-form-grid">
        <b-col cols="12">
          <div class="bdp-field">
            <label class="bdp-label">{{ msg('Real estates') }}</label>
            <real-estate-picker v-model="listingId"/>
          </div>
        </b-col>
        <b-col cols="12" md="6">
          <div class="bdp-field">
            <label class="bdp-label">{{ msg('Start') }}</label>
            <validation-provider #default="{ errors }" :name="msg('Start date')" rules="required">
              <calendar-picker v-model="start"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </div>
        </b-col>
        <b-col cols="12" md="6">
          <div class="bdp-field">
            <label class="bdp-label">{{ msg('End') }}</label>
            <validation-provider #default="{ errors }" :name="msg('End date')" rules="required">
              <calendar-picker v-model="end"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </div>
        </b-col>
        <b-col cols="12">
          <div class="bdp-field">
            <label class="bdp-label">{{ msg('Note') }}</label>
            <b-form-input v-model="note" class="bdp-input" :placeholder="msg('Optional note...')" />
          </div>
        </b-col>
      </b-row>

      <div class="text-center mt-2">
        <b-button variant="danger" class="bdp-btn" @click="blockCalendar(false)">
          <i class="fas fa-lock mr-50"></i> {{ msg('block') }}
        </b-button>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import RealEstatePicker from "@/components/components/picker/realEstatesPicker";

export default {
  name: 'blockDatesPanel',
  components: {RealEstatePicker},
  data() {
    return {
      loaded: false,
      error: null,
      listingId: null,
      start: null,
      end: null,
      note: null,
      listeners: {
        submit: () => {
        }
      }
    }
  },
  watch: {
    id: function () {
      this.onLoad()
      this.error = null
    },
  },
  created() {
    this.onLoad()
    this.$root.$on('crm::submitBlock', (this.listeners.submit = () => {
      this.submit()
    }))
  },
  beforeDestroy() {
    this.$root.$off('crm::submitBlock', this.listeners.submit)
  },
  methods: {
    ...mapActions('realEstateContracts', {
      _createContractMulti: 'createContractMulti',
    }),
    ...mapActions('hostaway', ['blockCalendarDates']),
    onLoad() {
      this.loaded = true
    },
    blockCalendar(isAvailable) {
      let $this = this
      let request = {
        startDate: this.start,
        endDate: this.end,
        note: this.note,
        isAvailable: isAvailable
      }
      this.$refs['refFormObserver'].validate().then(valid => {
        if (!valid)
          return;
        $this.blockCalendarDates({listingId: this.listingId, request: request})
            .then(
                (id) => {
                  $this.contractId = id
                  $this.$emit('submitted', {
                    status: true,
                    server: id,
                    id
                  })
                },
                (a) => $this.$emit('submitted', {
                  status: false,
                  server: a
                })
            )
      })
    },
    setData(start, end, listingId){
      console.log('setData', start, end, listingId)
      this.start = start
      this.end = end
      this.listingId = listingId
      this.loaded = true
    },
    validate(field) {
      return this.$v.contract[field] != null && this.$v.contract[field].$error === true
    },
    submit() {
      return this.blockCalendar()
    }
  }
}
</script>

<style scoped>
.bdp-panel { padding: 8px; }
.bdp-header { display: flex; align-items: center; gap: 12px; margin-bottom: 24px; }
.bdp-header-icon { width: 44px; height: 44px; border-radius: 14px; display: flex; align-items: center; justify-content: center; background: rgba(234,84,85,.12); color: #ea5455; font-size: 18px; flex-shrink: 0; }
.bdp-header-title { font-weight: 900; font-size: 16px; }
.bdp-header-sub { font-size: 12px; opacity: .6; }
.bdp-form-grid { row-gap: 8px; }
.bdp-field { margin-bottom: 12px; }
.bdp-label { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .4px; opacity: .65; margin-bottom: 4px; display: block; }
.bdp-input { border-radius: 10px; }
.bdp-btn { border-radius: 12px; font-weight: 700; padding: 8px 28px; }
</style>
